<div class="w-full p-4 sm:p-8">
    <mat-card class="h-full flex flex-col">

        <mat-card-header class="!p-6" *ngIf="!isRotating">
            <mat-card-title class="flex flex-wrap items-center gap-2">
                <ng-container *ngIf="userUiType !== 4; else ambassadorGalleryTitle">Image Gallery</ng-container>
                <ng-template #ambassadorGalleryTitle>Your Media Gallery</ng-template>

                <mat-icon
                    class="text-gray-500"
                    svgIcon="heroicons_outline:information-circle"
                    [matTooltip]="userUiType === 4 ? 'Upload additional photos of yourself or your travels.' : 'Manage all images for this destination.'">
                </mat-icon>

                <span *ngIf="isGalleryInsufficient()" class="bg-red-500 text-white px-2 py-0.5 rounded text-xs font-bold animate-pulse shadow-sm whitespace-nowrap">
                    ⚠️ Needs > 0 Image
                </span>
                <span *ngIf="isMissingImage(destination?.im_media)" class="bg-red-500 text-white px-2 py-0.5 rounded text-xs font-bold animate-pulse shadow-sm whitespace-nowrap">
                    ⚠️ Missing Banner Image
                </span>
                <span *ngIf="isMissingImage(destination?.im_mediacard)" class="bg-red-500 text-white px-2 py-0.5 rounded text-xs font-bold animate-pulse shadow-sm whitespace-nowrap">
                    ⚠️ Missing Card Image
                </span>
            </mat-card-title>
            <span class="flex-auto"></span>
            <button
                mat-stroked-button
                (click)="onFileInputClick('FileUploadGallery')">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span class="hidden sm:inline ml-2">
                    <ng-container *ngIf="userUiType !== 4; else ambassadorUploadBtn">Add Image</ng-container>
                    <ng-template #ambassadorUploadBtn>Upload Media</ng-template>
                </span>
            </button>
            <input hidden type="file" multiple id="FileUploadGallery" (change)="handleFileUpload($event)" accept="image/*"/>
        </mat-card-header>

        <mat-card-content class="p-6" *ngIf="!isRotating">
            <div *ngIf="destination.ar_gallery?.length > 0" class="flex flex-wrap items-center gap-2 mb-4 border rounded-lg p-2 bg-gray-50 dark:bg-gray-700">
                <span class="text-sm font-medium text-gray-600 dark:text-gray-200">Selected:</span>
                <button mat-flat-button color="primary" [disabled]="selectedGalleryImageIndex === null" (click)="setImageToBanner('main')">
                    <mat-icon svgIcon="heroicons_solid:photo"></mat-icon>
                    <span class="hidden sm:inline ml-2">
                        <ng-container *ngIf="userUiType !== 4; else ambassadorSetBannerBtn">Set as Banner</ng-container>
                        <ng-template #ambassadorSetBannerBtn>Set as Profile Banner</ng-template>
                    </span>
                    <span *ngIf="isMissingImage(destination?.im_media)" class="ml-2 animate-pulse text-xl" title="Missing Banner Image">⚠️</span>
                </button>
                <button mat-flat-button color="primary" [disabled]="selectedGalleryImageIndex === null" (click)="setImageToBanner('card')">
                    <mat-icon svgIcon="heroicons_solid:view-columns"></mat-icon>
                    <span class="hidden sm:inline ml-2">
                        <ng-container *ngIf="userUiType !== 4; else ambassadorSetCardBtn">Set as Card</ng-container>
                        <ng-template #ambassadorSetCardBtn>Set as Profile Picture</ng-template>
                    </span>
                    <span *ngIf="isMissingImage(destination?.im_mediacard)" class="ml-2 animate-pulse text-xl" title="Missing Card Image">⚠️</span>
                </button>
                <span class="flex-auto"></span>
                <button mat-icon-button color="accent" [disabled]="selectedGalleryImageIndex === null" (click)="startRotationMode()" matTooltip="Rotate Image" *ngIf="false">
                    <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                </button>
                <button mat-icon-button color="warn" [disabled]="selectedGalleryImageIndex === null" (click)="removeGalleryImage()" matTooltip="Delete Current Image">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
                <button mat-icon-button [disabled]="selectedGalleryImageIndex === null"
                        (click)="openInNewTab(destination.ar_gallery[selectedGalleryImageIndex]?.im_media)"
                        matTooltip="Open in New Tab">
                    <mat-icon>open_in_new</mat-icon>
                </button>
            </div>

            <div *ngIf="destination.ar_gallery && destination.ar_gallery.length > 0; else noImagesPlaceholder"
                 class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                <div *ngFor="let img of destination.ar_gallery; let i = index"
                     class="relative aspect-square rounded-lg overflow-hidden cursor-pointer group"
                     [class.ring-4]="i === selectedGalleryImageIndex"
                     [class.ring-blue-500]="i === selectedGalleryImageIndex"
                     [class.ring-offset-2]="i === selectedGalleryImageIndex"
                     (click)="selectedGalleryImageIndex = i">
                    <img [src]="img.im_media" alt="Gallery Image" class="w-full h-full object-cover">
                    <div class="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                         [class.opacity-100]="i === selectedGalleryImageIndex">
                        <mat-icon *ngIf="i === selectedGalleryImageIndex" class="text-white text-5xl opacity-80" svgIcon="heroicons_solid:check-circle"></mat-icon>
                    </div>
                </div>
            </div>

            <ng-template #noImagesPlaceholder>
                <div class="flex flex-col items-center justify-center h-64 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-500 dark:text-gray-400 relative">
                    <mat-icon class="!w-20 !h-20 text-gray-400" svgIcon="heroicons_outline:photo"></mat-icon>
                    <p class="mt-4 text-lg font-medium">
                        <ng-container *ngIf="userUiType !== 4; else ambassadorNoMedia">No images yet</ng-container>
                        <ng-template #ambassadorNoMedia>No media yet</ng-template>
                    </p>
                    <p class="text-sm">
                        <ng-container *ngIf="userUiType !== 4; else ambassadorUploadPrompt">Click "Add Image" to upload your first photo.</ng-container>
                        <ng-template #ambassadorUploadPrompt>Click "Upload Media" to add your first photo.</ng-template>
                    </p>
                </div>
            </ng-template>
        </mat-card-content>

        <div *ngIf="isRotating" class="flex flex-col h-full bg-white dark:bg-gray-800 rounded-lg overflow-hidden">
            <div class="flex items-center justify-between p-4 border-b bg-gray-50 dark:bg-gray-700">
                <div class="flex items-center">
                    <button mat-icon-button (click)="cancelRotation()" class="mr-2">
                        <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
                    </button>
                    <h2 class="text-lg font-medium m-0">Adjust Rotation</h2>
                </div>
                <button mat-flat-button color="primary" (click)="saveRotatedImage()">
                    <mat-icon class="mr-2" svgIcon="heroicons_outline:check"></mat-icon>
                    Save Copy
                </button>
            </div>

            <div class="flex-auto flex items-center justify-center p-8 bg-gray-100 dark:bg-gray-900 overflow-hidden relative">
                <div class="relative flex items-center justify-center" style="width: 80%; height: 80%;">
                    <img [src]="rotationImageBlobUrl"
                         [style.transform]="'rotate(' + rotationDegree + 'deg)'"
                         class="max-w-full max-h-full object-contain transition-transform duration-300 shadow-2xl rounded">
                </div>
            </div>

            <div class="flex justify-center items-center gap-8 p-6 border-t bg-gray-50 dark:bg-gray-700">
                <button mat-stroked-button (click)="rotateLeft()" class="!px-6 !py-1">
                    <mat-icon class="mr-2">rotate_left</mat-icon> Rotate Left
                </button>
                <div class="text-lg font-bold w-16 text-center text-gray-500">{{rotationDegree}}°</div>
                <button mat-stroked-button (click)="rotateRight()" class="!px-6 !py-1">
                    Rotate Right <mat-icon class="ml-2">rotate_right</mat-icon>
                </button>
            </div>
        </div>

    </mat-card>
</div>
